import { createContext, ReactNode, useContext, useMemo, useRef } from "react";

import { useContainerHeight, useContainerWidth } from "@/hooks";

interface ChatWidgetContextValue {
  isContainerSizeSmall: boolean;
  containerRef: React.RefObject<HTMLDivElement | null>;
  variableSetIndex: number;
}

const ChatWidgetContext = createContext<ChatWidgetContextValue | null>(null);

export const useChatWidgetContext = () => {
  const context = useContext(ChatWidgetContext);
  if (!context) {
    throw new Error("useChatWidgetContext must be used within ChatWidgetProvider");
  }
  return context;
};

interface ChatWidgetProviderProps {
  children: ReactNode;
  variableSetIndex: number;
}

export const ChatWidgetProvider = ({ children, variableSetIndex }: ChatWidgetProviderProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const containerWidth = useContainerWidth(containerRef);
  const containerHeight = useContainerHeight(containerRef);
  const isContainerSizeSmall = useMemo(
    () => containerWidth < 400 || containerHeight < 400,
    [containerWidth, containerHeight],
  );

  return (
    <ChatWidgetContext.Provider value={{ isContainerSizeSmall, containerRef, variableSetIndex }}>
      {children}
    </ChatWidgetContext.Provider>
  );
};
